import gql from 'graphql-tag';
import { QUESTION_TYPE, QUESTION_TYPE_VALUES } from './QuestionType.gql';


export const QUESTION_TYPE_CONNECTION = gql`
  ${QUESTION_TYPE}
  fragment QuestionTypeConnection on QuestionTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...QuestionType
      }
    }
    totalCount
    edgeCount
  }
`;

export const QUESTION_TYPE_VALUES_CONNECTION = gql`
  ${QUESTION_TYPE_VALUES}
  fragment QuestionTypeConnection on QuestionTypeConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        ...QuestionType
      }
    }
    totalCount
    edgeCount
  }
`;
